const initialized = new WeakSet<HTMLElement>();

export function initializeCharts(scope: ParentNode = document): void {
  scope.querySelectorAll<HTMLElement>("[data-chart]:not([data-chart-static])").forEach(chart => {
    if (initialized.has(chart)) return;
    initialized.add(chart);
    const slices = Array.from(chart.querySelectorAll<HTMLElement>("[data-chart-slice]"));
    const views = Array.from(chart.querySelectorAll<HTMLElement>("[data-chart-measure]"));
    const select = chart.querySelector<HTMLSelectElement>("[data-chart-select]");
    const measureSelect = chart.querySelector<HTMLSelectElement>("[data-chart-measure-select]");
    const all = chart.querySelector<HTMLInputElement>("[data-chart-all]");
    const status = chart.querySelector<HTMLElement>("[data-chart-status]");
    let sliceId = chart.dataset.chartDefaultSlice ?? slices[0]?.dataset.chartSlice;
    let measure = chart.dataset.chartDefaultMeasure ?? "value";

    function update(announce = true) {
      for (const slice of slices) {
        setSearchableHidden(slice, !all?.checked && slice.dataset.chartSlice !== sliceId);
      }
      for (const view of views) setSearchableHidden(view, view.dataset.chartMeasure !== measure);
      if (select && sliceId) select.value = sliceId;
      if (select) select.disabled = all?.checked ?? false;
      if (measureSelect) measureSelect.value = measure;
      if (announce && status) {
        status.textContent = [all?.checked ? all.parentElement?.textContent?.trim() : select?.selectedOptions[0]?.textContent, measureSelect?.selectedOptions[0]?.textContent].filter(Boolean).join(" · ");
      }
    }
    select?.addEventListener("change", () => { sliceId = select.value; update(); });
    measureSelect?.addEventListener("change", () => { measure = measureSelect.value; update(); });
    all?.addEventListener("change", () => update());
    // Browser Find reveals the exact existing panel instead of finding data in an invisible clone.
    chart.addEventListener("beforematch", event => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      const slice = target.closest<HTMLElement>("[data-chart-slice]");
      const view = target.closest<HTMLElement>("[data-chart-measure]");
      if (slice) sliceId = slice.dataset.chartSlice;
      if (view) measure = view.dataset.chartMeasure ?? measure;
      if (all) all.checked = false;
      update();
    });
    chart.querySelector<HTMLElement>("[data-chart-controls]")?.removeAttribute("hidden");
    update(false);
  });
}

function setSearchableHidden(element: HTMLElement, hide: boolean): void {
  if (hide) element.setAttribute("hidden", "until-found");
  else element.removeAttribute("hidden");
}
